import { render, staticRenderFns } from "./control-tags.vue?vue&type=template&id=1e5d53b2"
import script from "./control-tags.vue?vue&type=script&lang=js"
export * from "./control-tags.vue?vue&type=script&lang=js"
import style0 from "./control-tags.vue?vue&type=style&index=0&id=1e5d53b2&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports